import { render, staticRenderFns } from "./vProductos.vue?vue&type=template&id=4807d33e&scoped=true"
import script from "./vProductos.vue?vue&type=script&lang=js"
export * from "./vProductos.vue?vue&type=script&lang=js"
import style0 from "./vProductos.vue?vue&type=style&index=0&id=4807d33e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4807d33e",
  null
  
)

export default component.exports